/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/training.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';

const EvaluationInterview = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '승인 요청', value: 0},
    {title: '합격', value: 1},
    {title: '조건부 합격', value: 2},
    {title: '불합격', value: 3}
  ];
  return (
    <main className="com_container com_training p_evaluation_interview">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_1">면접 평가</h2>
          <Link to="/Training/EvaluationInterview/Register" className="com_btn orange s btn_plus">
            면접평가 등록
          </Link>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <button className="com_btn lightGray s">내 보고서</button>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="10%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="9%" />
                <col width="15%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="9%" />
                <col width="10%" />
                <col width="25%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>지점</th>
                  <th>과목</th>
                  <th>이름</th>
                  <th>나이/성별</th>
                  <th>학력</th>
                  <th>면접</th>
                  <th>시강</th>
                  <th>등급</th>
                  <th>면접자</th>
                  <th>면접일시</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="icon_new" />
                    17
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>본사</td>
                  <td>수학</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>울산과학기술원</td>
                  <td>35</td>
                  <td>37</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_point">승인요청</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>서울대 독어독문</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_point">
                    조건부 합격 <br />
                    2023,05,10
                  </td>
                </tr>
                <tr>
                  <td>15</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>고려대 화학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_red">
                    불합격 <br />
                    2023,05, 10
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>울산과학기술원</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_red">탈락</td>
                </tr>
                <tr className="selected">
                  <td>13</td>
                  <td className="td_date">2022,08,25</td>
                  <td>본사</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>32/남</td>
                  <td>동국대 수학과</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_point">
                    조건부 합격 <br />
                    2023,05,10
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_point">승인요청</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>10</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>32/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>9</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>8</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>32/남</td>
                  <td>동국대 수학과</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>32/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>23</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>3</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>32/남</td>
                  <td>동국대 수학과</td>
                  <td>38</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>2</td>
                  <td className="td_date">2022,08,25</td>
                  <td>겸업</td>
                  <td>영어</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>동국대 수학과</td>
                  <td>29</td>
                  <td>35</td>
                  <td>C-</td>
                  <td>김면접103</td>
                  <td>
                    20223, 01, 23
                    <br /> 18:30
                  </td>
                  <td className="td_point">승인요청</td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <div className="paging_wrap">
                <Paging />
              </div>
              <select className="select end">
                <option value="합격">합격</option>
              </select>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">면접 평가 상세</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit"></button>
              </div>
            </div>
            <div className="com_icon red">불합격</div>

            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">지점/과목</span>
                  <span className="cont">본사 / 영어</span>
                </div>
                <div className="info">
                  <span className="tit">이름</span>
                  <span className="cont bold">김교사</span>
                </div>
                <div className="info">
                  <span className="tit">나이/성별</span>
                  <span className="cont">1979,12 / 여</span>
                </div>
                <div className="info">
                  <span className="tit">거주지</span>
                  <span className="cont com_blue_txt">서울 / 송파구</span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <span className="cont com_blue_txt">010-1234-4567</span>
                </div>
                <div className="info">
                  <span className="tit">학력</span>
                  <span className="cont">서울 고려대 / 생명공학</span>
                </div>
                <div className="info">
                  <span className="tit">면접 유입경로</span>
                  <span className="cont">신규</span>
                </div>
                <div className="info">
                  <span className="tit">소개자</span>
                  <span className="cont">김소개103</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">면접관</span>
                  <span className="cont bold">김면접103</span>
                </div>
                <div className="info">
                  <span className="tit">기프트콘 발송</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">면접방식 </span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">면접일시</span>
                  <span className="cont">2023, 05, 12 15:30</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">시강점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">면접관 가산점수</span>
                  <span className="cont com_blue_txt">4점</span>
                </div>
                <div className="info">
                  <span className="tit">교육의지 </span>
                  <span className="cont com_blue_txt">좋음</span>
                </div>
                <div className="info">
                  <span className="tit">교사 교육 가능일시 </span>
                  <span className="cont com_blue_txt"> 2024, 05, 12 ㅣ 22 : 30</span>
                </div>
                <div className="info">
                  <span className="tit">점수/등급</span>
                  <span className="cont com_red_txt">158점 C등급</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접관 의견</span>
                  <span className="cont">태도나 모든 것이 좋으나 기타 다른 부분이 미흡합니다.</span>
                </div>
                <div className="info">
                  <span className="tit">파일명</span>
                  <span className="cont">
                    <div className="com_input_upload">
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </span>
                </div>
              </div>

              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">합격</span>
                    <span className="com_icon blue">배정팀</span>
                    <button className="name">홍길동103 </button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">수고하셨습니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <div className="cont">
                    <span className="com_icon red">합격</span>
                    <span className="com_icon blue">교무실장</span>
                    <button className="name">홍길동103 </button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">수고하셨습니다.</div>
              </div>
            </div>

            <div className="com_comment_wrap">
              <div className="com_input_wrap">
                <select className="select">
                  <option value="불합격">불합격</option>
                </select>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="불합격" />
                <button className="com_btn orange l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default EvaluationInterview;
